import { useContext } from 'react';
import * as pumpCalc from '../../pumpfun/calc';
import * as bonkCalc from '../../letsbonk/calc';
import { LiveDataPumpTokensContext } from './context/LiveDataPumpTokensContext';
import { LiveDataBonkTokensContext } from './context/LiveDataBonkTokensContext';
import { FeedToken } from './types';
import { SolPriceContext } from '../../Components/SolPriceProvider';

export function LiveDataPumpfunToken<T extends FeedToken>(props: {
    token: T;
    children: (token: T, bondingCurve: number | null, marketCap: number | null) => React.ReactNode;
}) {
    const solPrice = useContext(SolPriceContext);

    const latestTokens = useContext(LiveDataPumpTokensContext);
    const token = props.token;

    const updated = latestTokens?.[token.mint]
        ? {
              ...token,
              ...latestTokens[token.mint],
          }
        : token;

    const bondingCurve = latestTokens?.[token.mint] ? pumpCalc.getBondingCurveProgress(latestTokens[token.mint]) : null;
    const marketCap = latestTokens?.[token.mint] ? pumpCalc.calculateMarketCap(latestTokens[token.mint], solPrice) : null;

    return props.children(updated, bondingCurve, marketCap);
}

export function LiveDataLetsBonkToken<T extends FeedToken>(props: {
    token: T;
    children: (token: T, bondingCurve: number | null, marketCap: number | null) => React.ReactNode;
}) {
    const solPrice = useContext(SolPriceContext);

    const latestTokens = useContext(LiveDataBonkTokensContext);
    const token = props.token;

    const updated = latestTokens?.[token.mint]
        ? {
              ...token,
              ...latestTokens[token.mint],
          }
        : token;

    const bondingCurve = latestTokens?.[token.mint] ? bonkCalc.getBondingCurveProgress(latestTokens[token.mint]) : null;
    const marketCap = latestTokens?.[token.mint] ? bonkCalc.calculateMarketCap(latestTokens[token.mint], solPrice) : null;

    return props.children(updated, bondingCurve, marketCap);
}
